'use client';

import { CalculatorShell } from 'components/Widget/shared/CalculatorShell';
import { DISCLAIMER, PLACEHOLDER_BODY, TITLE } from './constants';

export const PaycheckCalculator = () => (
  <CalculatorShell title={TITLE} disclaimer={DISCLAIMER} collapsibleDisclaimer>
    <p className="text-body-md">{PLACEHOLDER_BODY}</p>
  </CalculatorShell>
);
